import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { NodeType } from '../../../../@types';
import { DropdownItem } from '../../../../components/atoms/SelectMenu';
import { ClientContractBrandPanel } from '../../../../components/molecules/ClientContractBrandPanel';
import { SECTION_LABEL_SX } from '../constants';

export interface FiltersSectionProps {
  clients: DropdownItem[];
  contracts: DropdownItem[];
  brands: DropdownItem[];
  clientId: number;
  contractId: number;
  brandId: number;
  error?: string;
  onChangeNodeType: (nodeType: NodeType, parentId: string) => void;
  onParentSelect: (nodeId: number) => void;
  onClear?: () => void;
  canClear?: boolean;
  disabled?: boolean;
}

export const FiltersSection: React.FC<FiltersSectionProps> = ({
  clients,
  contracts,
  brands,
  clientId,
  contractId,
  brandId,
  error,
  onChangeNodeType,
  onParentSelect,
  onClear,
  canClear = clientId > 0 || contractId > 0 || brandId > 0,
  disabled,
}) => {
  const [interacted, setInteracted] = useState(false);
  useEffect(() => {
    if (clientId > 0) setInteracted(false);
  }, [clientId]);
  const visibleError = interacted ? error : undefined;
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography sx={{ ...SECTION_LABEL_SX, mb: 0 }}>Client / Contract / Brand</Typography>
        {onClear && (
          <Button
            size="small"
            onClick={onClear}
            disabled={!canClear}
            sx={{ textTransform: 'none', fontSize: '12px', minWidth: 0, p: 0.25 }}
          >
            Clear
          </Button>
        )}
      </Box>
      <Box
        aria-disabled={disabled || undefined}
        onFocus={() => setInteracted(true)}
        onMouseDown={() => setInteracted(true)}
        sx={{ opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? 'none' : 'auto' }}
      >
        <ClientContractBrandPanel
          isNew
          error={!!visibleError}
          clients={clients}
          contracts={contracts}
          brands={brands}
          clientId={clientId}
          contractId={contractId}
          brandId={brandId}
          disableContract={contracts.length <= 1}
          disableBrand={brands.length <= 1}
          onChangeNodeType={onChangeNodeType}
          onParentSelect={(nodeId) => onParentSelect(nodeId)}
          locationSearchEnabled={false}
          pageType="add-service"
        />
      </Box>
      {visibleError && (
        <Typography sx={{ fontSize: '12px', color: 'error.main', mt: 0.5 }}>
          {visibleError}
        </Typography>
      )}
    </Box>
  );
};
